import { render, staticRenderFns } from "./BtnExcluirAnexo.vue?vue&type=template&id=08c9069d&"
import script from "./BtnExcluirAnexo.vue?vue&type=script&lang=js&"
export * from "./BtnExcluirAnexo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports